<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-file-alt"></i>&nbsp;
    <ng-container i18n *ngIf="!isEdit">Add Product</ng-container>
    <ng-container i18n *ngIf="isEdit">Edit Product</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <span><i class="far fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="roomId" placeholder="Room" required (selectionChange)="onRoomChange($event)">
            <mat-option *ngFor="let unit of units" [value]="unit.unit_id">
              {{ unitNamesById[unit.unit_name_id]?.unit_name || 'Unknown' }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="rateId" placeholder="Rate" required>
            <mat-option *ngFor="let rate of filteredRates" [value]="rate.id">
              {{ rate.name }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-8">
            <mat-form-field2
              class="mat-block"
              matTooltip="Set the minimum lead time for a booking with this rate."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="minAdvancedBookingOffset"
                matInput
                placeholder="Min advance bookings"
              />
              <span matSuffix>Days</span>
              <mat-error *ngIf="form.get('minAdvancedBookingOffset')?.errors?.positive">
                <ng-container i18n>Minimum advance booking must be greater than 0</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
      </div>
      <div class="col-sm-12 d-none">
        <div class="row">
          <div class="col-sm-8">
            <mat-form-field2
              class="mat-block"
              matTooltip="Set how far in advance this rate may be booked."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="maxAdvancedBookingOffset"
                matInput
                placeholder="Max advance booking"
              />
              <mat-error *ngIf="form.get('maxAdvancedBookingOffset')?.errors?.positive">
                <ng-container i18n>Maximum advance booking must be greater than 0</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-sm-4">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="maxAdvancedBookingOffsetType" placeholder="Type">
                <mat-option *ngFor="let type of advancedBookingOffsetTypes" [value]="type.value">{{
                  type.label
                }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="form-field-label mb-2" i18n>Do you want to set a meal plan?</div>
        <mat-radio-group [formControl]="mealPlanActiveCtrl" class="d-flex flex-column mb-3">
          <mat-radio-button [value]="false">No</mat-radio-button>
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <div *ngIf="mealPlanActiveCtrl.value" class="ml-4 d-flex gap-3">
            <mat-checkbox [formControl]="mealPlansBreakfastCtrl">Breakfast</mat-checkbox>
            <mat-checkbox [formControl]="mealPlansLunchCtrl">Lunch</mat-checkbox>
            <mat-checkbox [formControl]="mealPlansDinnerCtrl">Dinner</mat-checkbox>
          </div>
        </mat-radio-group>
      </div>
      <div class="col-sm-12">
        <mat-form-field2>
          <app-select
            [items]="cancelPolicies"
            bindLabel="cancelPenalty.description"
            bindValue="cancelPenalty.policyCode"
            formControlName="policyCode"
            [multiple]="false"
            [searchable]="true"
            placeholder="Cancellation Policy"
          >
          </app-select>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="isLoading">
    <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
